import { Button, Space, Form, Input, message } from 'antd';
import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import {} from '@ant-design/icons';
import { useEventEmitter } from '&/utils/customHooks/useEventEmitter';
import BaseModal from '&/components/BaseModal';
import {} from '&/utils/common';
import {
    addPlan,
    // regConstruction,
} from '&/components/TemplateManagement/common';
import { postPlanCopy } from '&/api/personCenter/templateSettings';
import './index.scss';

const editConstructionTemplateModal = forwardRef((props, ref) => {
    const { templateData = {}, showEditModal, type } = props;

    const [saveFrom] = Form.useForm();

    const [visible, setVisible] = useState(false);
    const [title, setTitle] = useState('');

    const { emit } = useEventEmitter();

    useImperativeHandle(ref, () => {
        return { show, hide };
    });

    useEffect(() => {}, []);

    useEffect(() => {
        if (visible) initModal();
    }, [visible]);

    useEffect(() => {}, []);

    const show = () => {
        setVisible(true);
    };
    const hide = () => {
        setVisible(false);
    };

    const initModal = () => {
        let value = {
            templateName: '',
            remark: '',
        };
        let msg = intl.get('templateSettings.addTemplate');

        if (templateData.originalItem) {
            value.templateName = templateData.originalItem.name;
            value.remark = templateData.originalItem.remark || '';
            if (type === 'edit') {
                msg = intl.get('templateSettings.editTemplate');
            } else if (type === 'copy') {
                const ectype = intl.get('templateSettings.ectype');
                if (value.templateName.length > 13) {
                    value.templateName = `${value.templateName.slice(
                        0,
                        12
                    )}-${ectype}`;
                } else {
                    value.templateName = `${value.templateName}-${ectype}`;
                }
                msg = intl.get('templateSettings.copyTemplate');
            }
        }
        saveFrom.setFieldsValue(value);
        setTitle(msg);
    };

    const confirm = async () => {
        try {
            const values = await saveFrom.validateFields();

            if (type === 'copy') {
                const sendData = {
                    tempName: values.templateName,
                    remark: values.remark,
                    tempId: templateData.id,
                };
                await postPlanCopy(sendData);
                message.success(intl.get('templateSettings.copySuccess'));
            } else {
                const sendData = {
                    tempPlanName: values.templateName,
                    remark: values.remark,
                    id: templateData.id,
                };
                await addPlan(sendData);
            }
            emit('query-template-list', {
                callback: list => {
                    showEditModal?.(list);
                },
            });
            hide();
        } catch (e) {}
    };

    return (
        <BaseModal
            className="edit-construction-template-modal"
            title={title}
            onCancel={hide}
            visible={visible}
            width="350px"
            footer={
                <Space>
                    <Button onClick={hide}>{intl.get('base.cancel')}</Button>
                    <Button type="primary" onClick={confirm}>
                        {intl.get('base.confirm')}
                    </Button>
                </Space>
            }>
            <Form
                labelCol={{ span: 6 }}
                form={saveFrom}
                onFinish={() => {}}
                className="add-form">
                <Form.Item
                    name="templateName"
                    label={intl.get('templateSettings.templateName')}
                    rules={[
                        { required: true },
                        /*{
                            validator: async (rule, value) => {
                                if (!regConstruction.test(value)) {
                                    const msg = intl.get(
                                        'templateSettings.constructionStageErrorMsg'
                                    );
                                    return Promise.reject(msg);
                                }
                                return Promise.resolve();
                            },
                        },*/
                    ]}>
                    <Input maxLength={15} />
                </Form.Item>
                <Form.Item
                    name="remark"
                    label={intl.get('templateSettings.remark')}>
                    <Input.TextArea maxLength={60} />
                </Form.Item>
            </Form>
        </BaseModal>
    );
});

export default editConstructionTemplateModal;
